export const customerLoyaltyCard = {
  loyalty_card: 'Loyalty Card',
  you_have_collected: `You've collected`,
  you_are_earning: `You're earning`,
  so_far: 'so far',
  start_collecting_today: 'Start collecting today',
  ready_to_collect: `Ready to redeem your`,
  ready_to_collect_short: `Ready to redeem`,
  reward: `reward!`,
  my_loyalty_cards: '{{chosenHeaderName}}s',
  loyalty_card_details: '{{chosenHeaderName}} Details',
  participating_businesses: 'Participating Businesses',
  participating_businesses_all: 'All Vendors',
  valid_dates: 'Valid Dates',
  valid_days: 'Valid Days',
  spend_to_qualify: 'Add {{amount}} to qualify',
  minimum_total_spend: 'Minimum Order Total',
  minimum_subtotal_spend: 'Minimum Order Subtotal',
  spend: 'Add',
  stamp_value: 'Stamp Value',
  orders: 'Orders',
  terms_and_conditions: 'Terms & Conditions',
  error_fetching: 'Error fetching this loyalty card',
  add: 'Add',
  redeem: 'Redeeming',
  saved: 'Saved',
  more_to_earn_a_stamp: 'to earn a stamp',
  more_to_earn_a_discount: 'to earn a discount',
  more_to_earn_a_stamp_short: 'more to earn',
  to_earn: 'to earn',
  earn: 'Earning',
  on_next_stamp: ' on your next stamp',
  on_first_stamp: 'on your first stamp',
  on_your_order: 'on your order',
  will_be_discounted:
    'will be automatically discounted against your next order. ',
  how_many_stamps_away: `You're only {{numberOfStamps}}away from using your discount. Order again for your next stamp. `,
  start_collecting_today_extra_info: `Start collecting today! Order from qualifying {{businessOrRestaurant}} to earn your first stamp.`,
  amount_saved: `{{amountSaved}}`,
  potential_to_earn: `{{potentialToEarn}}`,
  loyalty_cards_available: `{{numOfCards}} {{loyaltyCardHeaderName}}s`,
  cash_orders_not_accepted: 'This card does not accept cash orders.',
  unavailable_today: 'Unavailable today',
  card_unavailable_today: 'Sorry, this card is not available today.',
  get_fixed_value_off: 'Get {{value}} off',
  get_percentage_order_total: 'Collect {{value}}% of the order total',
  get_percentage_order_subtotal: 'Collect {{value}}% of the order subtotal',
  deals_and_offers: 'Deals & Offers',
  to_start_earning_offers: 'to start earning offers',
  to_select_items: 'to select items',
  select_before_payment: 'Earned! Checkout to select',
  discount_code: 'Discount Code',
}
